// Marks every horizontally scrolling container with data-sh="l" | "r" | "lr" (which edge still has content) so
// index.css can fade that edge (a card holding a wide table counts too: see the div:has(> table) rule) -- otherwise tab strips and wide tables just look cut off on phones and tablets.
const MIN = 4;

export function installScrollHints() {
  if (typeof window === "undefined" || typeof ResizeObserver === "undefined") return;
  const seen = new WeakSet();
  const update = (el) => {
    const max = el.scrollWidth - el.clientWidth;
    if (max <= MIN) { if (el.dataset.sh) delete el.dataset.sh; return; }
    const v = `${el.scrollLeft > MIN ? "l" : ""}${el.scrollLeft < max - MIN ? "r" : ""}`;
    if (el.dataset.sh !== v) el.dataset.sh = v;
  };
  const ro = new ResizeObserver((entries) => entries.forEach((e) => update(e.target)));
  const attach = (el) => {
    if (seen.has(el)) return;
    seen.add(el);
    el.addEventListener("scroll", () => update(el), { passive: true });
    ro.observe(el);
  };
  let queued = false;
  const scan = () => {
    queued = false;
    let els;
    try { els = document.querySelectorAll(".overflow-x-auto, div:has(> table), section:has(> table)"); } catch { els = document.querySelectorAll(".overflow-x-auto"); }
    els.forEach((el) => { attach(el); update(el); });
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(scan); } };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.addEventListener("resize", schedule);
  schedule();
}
